import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/home/Home';
import PollContent from '@/views/polls/PollContent';
import QuestionContent from '@/views/questions/QuestionContent';

Vue.use(Router);

// a poll is "open" if we are inside it
// -> if we display its content or a question of it
export const pollIsOpen = route => {
  return ['pollContent', 'questionContent'].includes(route.name);
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/polls/:pollId/',
      name: 'pollContent',
      component: PollContent
    },
    {
      path: '/polls/:pollId/questions/:questionId',
      name: 'questionContent',
      component: QuestionContent,
      pathMatch: 'full'
    }
  ]
});
